module.exports = __webpack_public_path__ + "img/hero.5013e794.png";